import React from 'react';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { LoadablePaint } from '@confluence/loadable';
import {
	CONTAINER_HOME_ID,
	CONTAINER_ADMIN_HOME_ID,
} from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import SpaceBase from '../../SpaceBase/index.js';
import type { ConfluenceEdition } from '@confluence/session-data/entry-points/SiteInformationQuery.js';

const AdminCenterSpacePage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-confluenceadmin-center" */ '@confluence/admin-center'
			)
		).AdminCenterSpacePage,
});

export const AdminCenterSpaceRoute: {
	({ params: { spaceKey } }: RouteMatch): React.JSX.Element;
	NAVIGATION_PARAMS(
		{
			name,
			params: { spaceKey },
		}: {
			name: any;
			params: {
				spaceKey: any;
			};
		},
		isNav4Enabled: any,
	): {
		Screen: {
			screenEvent: {
				name: string;
				id: any;
				attributes: {
					edition: ConfluenceEdition | null;
				};
			};
			pageState: {
				routeName: any;
				spaceKey: any;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = ({ params: { spaceKey } }: RouteMatch): React.JSX.Element => {
	return (
		<SpaceBase>
			<AdminCenterSpacePage spaceKey={spaceKey} />
		</SpaceBase>
	);
};

AdminCenterSpaceRoute.NAVIGATION_PARAMS = (
	{
		name,
		params: { spaceKey },
	}: {
		name: any;
		params: {
			spaceKey: any;
		};
	},
	isNav4Enabled: any,
): {
	Screen: {
		screenEvent: {
			name: string;
			id: any;
			attributes: {
				edition: ConfluenceEdition | null;
			};
		};
		pageState: {
			routeName: any;
			spaceKey: any;
		};
	};
	MainLayout: {
		navView: string;
	};
} => {
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const { edition } = useSessionData();
	return {
		Screen: {
			screenEvent: { name: 'adminCenterSpace', id: spaceKey, attributes: { edition } },
			pageState: {
				routeName: name,
				spaceKey,
			},
		},
		MainLayout: {
			navView: isNav4Enabled ? CONTAINER_ADMIN_HOME_ID : CONTAINER_HOME_ID,
		},
	};
};
